export const APPLAB_ACCENT = '#00897B';
export const APPLAB_ORANGE = '#FF6B00';

export const STATUS_LABELS = {
  active:       { label: 'Aktiv',        color: '#4CAF50' },
  beta:         { label: 'Beta',         color: '#FF9800' },
  coming_soon:  { label: 'Kommer snart', color: '#607D8B' },
};

export const CATEGORIES = [
  'Alla',
  'Anbud & Affär',
  'Medarbetare & HR',
  'Uppdrag & Ekonomi',
  'Facilitering',
  'Marknadsföring',
  'Verktyg',
];
